import React from 'react';

import { ISubQuestion } from 'modules/national-certificate';

import Options from '../options';
import TopSection from '../top-section';

interface IProps {
  subQuestions?: ISubQuestion[];
}

const Tests: React.FC<IProps> = ({ subQuestions }) => (
  <div className="h-101 space-y-3 overflow-y-auto rounded-xl border border-gray-200 p-3">
    {subQuestions?.map(question => (
      <div key={question?.id} className="rounded-xl bg-gray-50 p-3">
        <div className="mb-2 px-1">
          <TopSection testImage={question?.image} questionId={question?.question_id} title={question?.question_name} />
        </div>
        <Options testId={question?.id} options={question?.options} optionsStyle="bg-white" />
      </div>
    ))}
  </div>
);

export default Tests;
